import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IPendingAutomaticContract,
  IPendingProductContract,
  IPackageV1UpdateHistoryEntry,
} from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';

@Injectable({ providedIn: 'root' })
export class PackageV1UpdatesService {
  private url: string;
  private endpoint = 'package/api/package-v1-updates';

  constructor(
    @Inject(APP_CONFIG) environment: any,
    private http: HttpClient
  ) {
    this.url = environment.apiUrl;
    if (this.url.endsWith('/')) {
      this.url = this.url.substring(0, this.url.length - 1);
    }
    if (environment.name == 'localDev') {
      this.url = 'http://localhost:8101';
    }
  }

  public getPendingAutomaticContracts(): Observable<
    HttpResponse<IPendingAutomaticContract[]>
  > {
    return this.http.get<IPendingAutomaticContract[]>(
      `${this.url}/${this.endpoint}/pending/automatic-contracts`,
      { observe: 'response' }
    );
  }

  public refreshAutomaticContract(
    packageV1Id: string
  ): Observable<HttpResponse<void>> {
    return this.http.post<void>(
      `${this.url}/${this.endpoint}/automatic-contracts/${packageV1Id}/refresh`,
      {},
      { observe: 'response' }
    );
  }

  public getPendingProductContracts(): Observable<
    HttpResponse<IPendingProductContract[]>
  > {
    return this.http.get<IPendingProductContract[]>(
      `${this.url}/${this.endpoint}/pending/product-contracts`,
      { observe: 'response' }
    );
  }

  public syncProductContract(id: string): Observable<HttpResponse<void>> {
    return this.http.post<void>(
      `${this.url}/${this.endpoint}/product-contracts/${id}/sync`,
      {},
      { observe: 'response' }
    );
  }

  public getHistory(): Observable<
    HttpResponse<IPackageV1UpdateHistoryEntry[]>
  > {
    return this.http.get<IPackageV1UpdateHistoryEntry[]>(
      `${this.url}/${this.endpoint}/history`,
      { observe: 'response' }
    );
  }
}
